import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { PrimeReactProvider } from 'primereact/api';
import { twMerge } from 'tailwind-merge';
import { pdfjs } from 'react-pdf';
import Clarity from '@microsoft/clarity';
import App from './ui/App';
import { PrimeReactTailwindThemes, isProduction } from './constants';
import { store } from '@/store';
// tailwind css
import './index.css';
// primreact css
import 'primeicons/primeicons.css';
// react-pdf css
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { GlobalToastInitializer, GlobalToastProvider } from '@repo/atomic-components';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

if (isProduction()) {
  Clarity.init('wd16so6anw');
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider
        value={{
          unstyled: true,
          // @ts-expect-error PrimeReact internal types problem
          pt: PrimeReactTailwindThemes,
          ptOptions: {
            mergeSections: true,
            mergeProps: true,
            classNameMergeFunction: twMerge,
          },
        }}
      >
        <BrowserRouter>
          <GlobalToastProvider>
            <GlobalToastInitializer />
            <App />
          </GlobalToastProvider>
        </BrowserRouter>
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>,
);
